import * as React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Controller } from "react-hook-form";

export default function SelectFieldInput(props) {
  const {
    label,
    name,
    control,
    options = [],
    required,
    rules,
    fullWidth = true,
    sx = {},
  } = props;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <FormControl
          fullWidth={fullWidth}
          error={!!error}
          required={required}
          size={isMobile ? "medium" : "small"}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: theme.shape.borderRadius,
              fontSize: { xs: "0.875rem", sm: "1rem" },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.palette.grey[400],
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.palette.primary.dark,
                borderWidth: 2,
              },
            },
            "& .MuiInputLabel-root": {
              fontSize: { xs: "0.875rem", sm: "1rem" },
            },
            "& .MuiFormHelperText-root": {
              fontSize: { xs: "0.75rem", sm: "0.875rem" },
            },
            ...sx,
          }}
        >
          <InputLabel>{label}</InputLabel>
          <Select
            value={value || ""}
            onChange={onChange}
            label={label}
            MenuProps={{
              PaperProps: {
                sx: {
                  maxHeight: 300,
                  "& .MuiMenuItem-root": {
                    fontSize: { xs: "0.875rem", sm: "1rem" },
                  },
                },
              },
            }}
          >
            {options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    />
  );
}
